import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langydl, langpty, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "请输入您的国家":"Insira o seu país",
  "借贷审核中":"Empréstimo em verificação",
  "完成":"Concluído",
  "可用贷款池":"Fundo de empréstimos disponíveis",
  "直观易用的界面":"Interface intuitiva e fácil de usar",
  "访问 3,000 多个市场":"Acesse mais de 3.000 mercados",
  "实时更新和价格提醒":"Atualizações em tempo real e alertas de preço",
  "各种技术指标、分析工具和高级图表":"Vários indicadores técnicos, ferramentas de análise e gráficos avançados",
  "先进的对冲策略和综合风险管理工具":"Estratégias de hedge avançadas e ferramentas abrangentes de gestão de risco",
  "操作不熟练,试试模拟交易":"Não tem experiência? Experimente a simulação de trading",
  "访问我们的帮助中心,获取交易指南":"Visite o nosso centro de ajuda para guias de trading",
  "希望增进您的交易技巧？":"Deseja melhorar suas habilidades de trading?",
  "每月提取金额":"Valor mensal sacado",
  "交易者":"Trader",
  "亿":"Bilhões",
  "万":"Dezenas de milhares",
  "3000多种品类供您选择":"Mais de 3.000 categorias para escolher",
  "24小时交易量":"Volume de negociação 24h",
  "线上交易,请选择":"Negociação online, escolha",
  "交易所":"Exchange",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"Mais de 3.000 categorias, incluindo criptomoedas, metais preciosos, forex, petróleo bruto e mais",
  "立即交易":"Negocie agora",
  "希望增进您的交易技巧":"Deseja melhorar suas habilidades de trading",
  "访问我们的帮助中心,获取全面交易指南":"Visite nosso centro de ajuda para guias completos de trading",
  "去看看":"Vá ver",
  "操作不熟练,试试我们的模 拟交易功能":"Não tem prática? Experimente nosso simulador de trading",
  "免费体验交易,让您尽快上手":"Experimente o trading gratuitamente para começar bem",
  "马上体验":"Experimente agora",
  "充币":"Depósito de cripto",
  "提币":"Saque de cripto",
  "客服":"Atendimento ao cliente",
  "更多":"Mais",
  "热门品种":"Categorias mais populares",
  "卖出":"Vender",
  "买入":"Comprar",
  "了解我们的平台":"Conheça nossa plataforma",
  "直观易用":"Intuitiva e fácil",
  "的界面":"interface",
  "定期提供":"Fornecemos regularmente",
  "3,000多个市场":"mais de 3.000 mercados",
  "的实时更新和 价格警报":"atualizações em tempo real e alertas de preço",
  "各种技术指标":"Vários indicadores técnicos",
  "分析工具和高级图表":"ferramentas de análise e gráficos avançados",
  "套期保值模式和":"Modos de hedge e",
  "风险管理工具":"ferramentas de gestão de risco",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"Criamos uma plataforma de trading tecnologicamente avançada e amigável, para oferecer uma experiência completa e personalizada",
  "实时新闻咨询":"Notícias em tempo real",
  "紧跟我们的新闻、产品和活动信息":"Acompanhe nossas notícias, produtos e eventos",
  "阅读更多新闻":"Leia mais notícias",
  "合作伙伴等最新新闻动态":"Últimas novidades sobre parceiros e mais",
  "AI智能赚币":"Ganhe cripto com IA",
  "出金":"Saque de fundos",
  "随存随取":"Deposite e saque quando quiser",
  "一键即刻取出,从不等待":"Saque com um clique, sem esperas",
  "稳定":"Estável",
  "最稳健的理财":"A gestão financeira mais sólida",
  "稳定收益,您的理财助手":"Rendimento estável, seu assistente financeiro",
  "执行速度":"Velocidade de execução",
  "极速执行":"Execução ultrarrápida",
  "所有订单将以毫秒级别速度执行":"Todas as ordens são executadas em milissegundos",
  "每天发放":"Distribuição diária",
  "当天产生收益":"Gera rendimento no mesmo dia",
  "当天购买当天产生收益,24小时及时发放收益":"Compre hoje, gere rendimento hoje, distribuição em 24 horas",
  "现在就开始":"Comece agora",
  "交易全球金融市场":"Negocie nos mercados financeiros globais",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"Suporte para desktop e dispositivos móveis, negocie em qualquer lugar e a qualquer momento",
  "谷歌下载":"Baixe no Google",
  "下载":"Baixar",
  "公司":"Empresa",
  "关于我们":"Sobre nós",
  "许可证监督":"Supervisão de licenças",
  "帮助中心":"Central de ajuda",
  "政策":"Políticas",
  "条款与条件":"Termos e condições",
  "隐私政策":"Política de privacidade",
  "声明":"Declarações",
  "法律信息":"Informações legais",
  "免责声明":"Aviso de isenção",
  "风险警告":"Aviso de risco",
  "关于广告":"Sobre publicidade",
  currency: {
    bb: 'Trading à vista',
    bba: 'Conta à vista',
    hy: 'Trading de contratos',
    jg: 'Trading de opções',
    jg1: 'Contratos futuros',
    hya: 'Conta de contratos'
  },
  home:{
    user:'Escolha dos usuários',
    start:'Comece a negociar',
    trading:'Produtos de trading',
    fee:'Taxas mínimas',
    co:'Parceiros',
    varieties:'Instrumentos de trading',
    leading:'Na vanguarda da inovação Web3',
    market:'Tendências do mercado de instrumentos',
    explore:'Explore possibilidades infinitas',
    newcurrency:'Nova funcionalidade de subscrição!',
    alimited:'Novas criptos disponíveis, compre as que acredita ter potencial',
    get_start:'Comece agora',
    ai_coin:'Programa de IA em andamento',
    ai_text:'Comece a ganhar com IA, rendimento estável e alta rentabilidade',
    loan:'Funcionalidade de empréstimo ativa',
    loan_text:'Precisa de fundos? Solicite um empréstimo, liberação no mesmo dia',
    mobile_pc:'Use no celular e PC',
    pc_anytime:'Negocie em qualquer lugar:',
    pc_text:'Oferecemos ferramentas poderosas de análise gráfica: mais de 50 indicadores técnicos e ferramentas de análise. Seguro, confiável e com alta alavancagem, referência para investimentos online.',
    mobile_down:'Baixe agora',
    mobile_android:'Android',
    mobile_ios:'Apple Store',
    open_text:'Abra uma conta real ou experimente a conta demo gratuitamente',
    open_account:'Uma única conta',
    tocomplete:'Concluir',
    walletlogin:'Acesse com carteira'
  },
  index: {
    h24: 'Volume 24h',
    header_title: ['Escolha ' + window.GLOBAL.LANG_TITLE.tw + ' para seus ativos digitais'],
    header_small_title:'Plataforma completa para negociação de ativos digitais blockchain',
    header_msg: 'Segura - Estável - Confiável',
    register_title: 'Registre-se em ' + window.GLOBAL.LANG_TITLE.tw + ' e inicie sua jornada no trading',
    register_pl: 'Insira e-mail ou telefone',
    register: 'Registrar',
    featureTitleWhy: 'Por que nos escolher',
    featureTitle: 'Segura · Estável · Confiável',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'Tecnologia de carteira segura', msg: ['Tecnologia cold/hot wallet desenvolvida por equipes globais de segurança, nunca sofreu ataques.', ''] },
      { icon: icon2, title: 'Serviços completos de cripto', msg: ['Suporte spot e derivativos, seu assistente pessoal no mundo cripto.',''] },
      { icon: icon3, title: 'Clientes em todo o mundo', msg: ['Serviços completos para usuários em mais de 130 países.',''] }
    ],
    bannerList: [
      { icon: banner01,title: "Líder em segurança e estabilidade", msg: ["Smart contracts para segurança de ativos","Desempenho de trading real","Suporte 24/7"] },
      { icon: banner02,title: "Quero comprar e vender com facilidade", msg: ["Interface simples","Atualização imediata do saldo","Maioria das criptos disponíveis"] },
      { icon: banner03,title: "Quero ganhar com contratos futuros", msg: ["Conta ativa imediatamente","Trading estratégico","Trading 24/7, inclusive finais de semana"] }
    ],
    featureList2: [
      { icon: icon1_01, title: "Transparência", msg: ["Desempenho on-chain via blockchain e smart contracts",""] },
      { icon: icon1_02, title: "Investimento inteligente", msg: ["Estratégias diversificadas de especialistas em trading quantitativo",""] },
      { icon: icon1_03, title: "Classificação de risco", msg: ["Produtos personalizados para diferentes perfis de risco",""] },
      { icon: icon1_04, title: "Produtos diversificados", msg: ["Serviços inovadores para todos os tipos de usuários",""] }
    ],
    featureTitle2: 'Negocie em qualquer lugar, em qualquer dispositivo',
    featureMsg2: 'Suporte iOS, Android e todas as funcionalidades',
    tab: ['Principais', 'Top 24h'],
    thead: ['Par', 'Preço', 'Máx 24h', 'Mín 24h','Variação', 'Volume 24h', 'Ação'],
    more: 'Ver mais >',
    btn: 'Negociar',
    dealsTitle: 'Serviço completo de trading',
    dealsTab:[
      { title: 'Trading à vista', content: 'Troca de ativos digitais, com USDT como moeda base. Suporte para BTC, ETH, LTC e outros.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Trading de contratos', content: 'Derivativos digitais, suporte long/short, gestão de risco avançada, alavancagem de até 100x.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Favoritos', 'Contratos', 'À vista'],
    thead: ['Moeda', 'Preço', 'Var. 24h', 'Mín 24h', 'Máx 24h','Volume 24h', 'Ação'],
    nodata: 'Sem dados'
  },
  footer: {
    p: '©Copyright ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.tw + '. Todos os direitos reservados.',
    dd: [
      { dt: "Sobre nós", dd: [{ title: "Apresentação", id: 1 }, { title: "Central de ajuda", type: 'help' }] },
      { dt: "Suporte", dd: [{ title: "Termos", id: 3 }, { title: "Privacidade", id: 5 }] },
      { dt: "Contato", icon: true }
    ],
    terms: "Termos",
    serve: "Serviços",
    product: "Produtos",
  },
  nav: {
    btn: ["Acessar", "Registrar", "Ativos","Baixar App"],
    nav: [
      { title: "Mercado", path: "/market" },
      { title: "Trading", path: "/preciousMetal", name: 'preciousMetal'},
      { title: "Finanças", path: "/profit_index",name: 'profit_index' },
    ],
    nav2: [{ title: "Meus ativos", path: "/asset" }],
    menus: [
      { icon: langzh, title: "Central do usuário", path: "/setting" },
      { icon: langen, title: "Sair" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
 { icon: langydl, lang: "Italia", key: 'it' },
      { icon: langpty, lang: "Portugal", key: 'pt' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "Baixar"
  },
  register: {
    dl: ['Registro com telefone', 'Registro com e-mail'],
    title: 'Criar conta',
    country: 'Nacionalidade',
    country_info: 'A nacionalidade não pode ser alterada após o registro',
    account: 'Conta',
    code_text: 'Insira o código',
    code_btn: 'Obter código',
    code_unit: 's',
    code_no_data: 'O código não pode estar vazio',
    password_text: 'Insira a senha',
    password_again_text: 'Repita a senha',
    pid_text: 'Código de convite',
    pid_pl: 'Opcional',
    invitation_code_no_data: 'O código de convite é obrigatório',
    xy: 'Termos de serviço',
    xy_no_checked: 'Aceite os termos',
    agree: 'Li e aceito',
    register_btn: 'Registrar',
    bz: ['A nacionalidade não pode ser alterada.', 'Verifique também a pasta de spam.', 'Guarde suas credenciais.', 'Não use a mesma senha em outros sites.'],
    account_no_data: 'Insira a conta',
    code_no_equality: 'Código inválido',
    password_no_data: 'Insira a senha',
    password_no_equality: 'As senhas não coincidem'
  },
  bindmpwd: {
    title: 'Definir senha',
    account: 'Conta',
    code_text: 'Insira o código',
    code_btn: 'Obter código',
    code_unit: 's',
    password_text: 'Insira a senha',
    password_again_text: 'Repita a senha',
    code_no_data: 'Código obrigatório',
    code_no_equality: 'Código inválido',
    password_no_data: 'Senha obrigatória',
    password_no_equality: 'As senhas não coincidem',
    bindmpwd_btn: 'Confirmar',
    phone_no_data: 'Insira o número de telefone',
    password_login_text: 'Insira a senha de acesso',
    password_trade_text: 'Senha de 6 dígitos',
    password_again_tarde_text: 'Senha de 6 dígitos',
  },
  forgetpwd: {
    title: ['Alterar senha', 'Esqueci a senha'],
    account: 'Conta',
    code_text: 'Insira o código',
    code_btn: 'Obter código',
    code_unit: 's',
    password_text: 'Insira a senha',
    password_again_text: 'Repita a senha',
    phone_no_data: 'Insira o telefone',
    account_no_data: 'Insira a conta',
    code_no_data: 'Código obrigatório',
    code_no_equality: 'Código inválido',
    password_no_data: 'Senha obrigatória',
    password_no_equality: 'As senhas não coincidem',
    forgetpwd_btn: 'Confirmar'
  },
  bindphone: {
    title: 'Associar número de telefone',
    phone_text: 'Telefone',
  },
  person: {
    more: 'Carregar mais',
    no_more: 'Sem mais dados',
    index_center:"Central do usuário",
    index_menus: [
      { icon: zhsz, title: "Gestão de conta", path: '/setting' },
      { icon: sfrz, title: "Verificação de identidade", path: '/sfyz' },
      { icon: sfrz, title: "Verificação básica", path: '/smauth' },
      { icon: jtrz, title: "Verificação avançada", path: '/seniorauth' },
      { icon: jtrz, title: "Verificação de endereço", path: '/dzrz' },
      { icon: jtrz, title: "Compra rápida", path: '/kjmbSelect' },
      { icon: jtrz, title: "Pontuação de crédito", path: '/credit' },
      { icon: jtrz, title: "Registro de operações", path: '/deallog' },
      { icon: jtrz, title: "Registro de depósitos", path: '/cbjl' },
      { icon: jtrz, title: "Registro de saques", path: '/tbjl' },
    ],
    cbtb: 'Depósito/Saque de cripto',
    jymx: 'Detalhe de transações',
    xyf: {
      'title': 'Pontuação de crédito',
      'pgsj': 'Data de avaliação'
    },
    smrz:{
      title:'Verificação de identidade',
      sure_title:'Verificação aprovada',
      zj_type:'Tipo de documento',
      zj_info:['1. Os dados não podem ser alterados', '2. Não podem ser reutilizados'],
      zj_name:'Nome',
      zj_num:'Número do documento',
      zj_btn:'Confirmar',
      zj_rebtn:'Re-verificar',
      zj_sebtn:'Verificação avançada',
      zj_type_array:[{name:'Documento de identidade',type:'idcard'}],
      idCardArr: [
        { id: 1, name: "Documento de identidade" },
        { id: 2, name: "Passaporte" },
        { id: 3, name: "Carteira de motorista" },
        { id: 4, name: "Permissão de residência" },
        { id: 5, name: "Outro" }
      ],
      zj_data:{city:'Nacionalidade obrigatória',type:'Tipo de documento obrigatório',name:'Nome obrigatório',zj_num:'Número do documento obrigatório'},
      zsxm: 'Nome completo',
       qsrzsxm: 'Insira o nome completo',
       zjlx: 'Tipo de documento',
       qxzzjlx: 'Selecione o tipo de documento',
       sfz: 'Documento de identidade',
       zjhm: 'Número do documento',
       qsrzjhm: 'Insira o número do documento',
       sczjz: 'Enviar foto do documento',
       zjzm: 'Enviar frente',
       zjfm: 'Enviar verso',
       qsczjzm: 'Envie a frente',
       qsczjfm: 'Envie o verso',
       scqmz: 'Enviar foto com documento',
       qscscqmz: 'Envie foto com documento',
       zj: [
         { id: 1, title: 'Documento de identidade' },
         { id: 2, title: 'Passaporte' },
         { id: 3, title: 'Outro' },
       ],
       tj: 'Enviar',
       shz: 'Em verificação',
       shtg: 'Verificado'
      },
      gjrz:{
      title:'Verificação avançada',
      zj_info:['1. Formatos JPG, JPEG, PNG, máx 8MB.','2. Fotos nítidas, sem alterações.','3. Foto com rosto visível.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],
      },
      zhgl:{
      title:'Configurações de segurança',
      bind:[{bind_title:'Redefinir senha',bind_name:'E-mail'},{bind_title:'Definir senha de trading',bind_name:'E-mail'}]
      },
      wdtg:{
              own_code:'Código de convite pessoal',
              own_code_url:'Link de convite pessoal',
              own_push_title:'Meus convites',
              own_push_content:['Ganho total estimado','Pessoas convidadas','pessoas'],
              own_push_content_profit:['Ganhos nível 1','Ganhos nível 2','Ganhos nível 3','Ganhos nível 4'],
              own_push_content_num:['Convites nível 1','Convites nível 2','Convites nível 3','Convites nível 4'],
              own_push_profit_title: ['ID', 'Ganho', 'Observações','Data'],
              own_push_num_title: ['ID', 'Nome', 'Telefone','Data'],
      },
    jyzt_td: ['Data', 'Detalhe', 'Valor'],
    cbjl_td: ['Data', 'Moeda', 'Quantidade','Status'],
    sfrz_txt: ['Verificação de identidade', 'Aguardando verificação', 'Verificação avançada aprovada', 'Frente', 'Verso', 'Verificação','Falhou, tente novamente'],
    zhsz_txt: ['Nível de segurança: #', 'Nível de segurança: #, complete seus dados para mais segurança'],
    zhsz_m: 'Forte',
    zhsz_n: 'Fraco',
    zhsz_p: 'Inseguro',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Senha de acesso', value: 'Altere-a periodicamente por segurança.', value2:'',btn: 'Alterar', bind_email:'Associe e-mail ou telefone',path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Senha de trading', value: 'Defina a senha de trading', btn: 'Definir', path: '/bindmpwd' }
    ],
    sksz_txt: ['Configurações de recebimento', 'Salvar'],
    sksz_list: [
      { label: "Usuário:", pl: "Insira o usuário", key: "name" },
      { label: "Banco:", pl: "Insira o banco", key: "bank_name" },
      { label: "Número da conta:", pl: "Insira o número da conta", key: "bank_number" },
      { label: "Alipay:", pl: "Insira o Alipay", key: "alipay_account" },
      { label: "Nickname WeChat:", pl: "Insira o nickname WeChat", key: "weixin_nickname" },
      { label: "Conta WeChat:", pl: "Insira a conta WeChat", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Primeira',
    prev: 'Anterior',
    next: 'Próxima',
    last: 'Última',
    no_data: 'Sem dados',
  },
  asset: {
    title: 'Meus ativos',
    zjhz: 'Transferência de fundos',
    cb: 'Depósito',
    gz: 'Valor estimado em USDT',
    atnv: [],
    zh_title: 'Total de ativos:',
    index_title: 'Ativos',
    address_title: 'Moeda',
    address_txt: ['Selecione', 'Endereço de saque', 'Insira o conteúdo', 'Observações', 'Lista de endereços'],
    address_btn: ['Adicionar', 'Salvar', 'Excluir', 'Editar'],
    address_td: ['Moeda', 'Endereço de saque', 'Observações', 'Ações'],
    currency_td: ['Moeda', 'Disponível', 'Bloqueado', 'Equivalente'],
    table_title: 'Total de ativos:',
    table_address_title: 'Gestão de endereços de saque',
    table_td: ['Moeda', 'Disponível', 'Bloqueado', 'Equivalente', 'Ações'],
    table_btn: ['Depositar', 'Sacar', 'Registro', 'Transferir'],
    money_text: ['Endereço de saque', 'Selecione', 'Quantidade', 'Disponível:', 'Taxa', 'Valor líquido', 'Senha de trading','Memo','Saque mínimo '],
    money_btn: 'Sacar',
    xzbz: 'Selecione a moeda',
    money_msg: ['Atenção', 'Não envie ativos não USDT para este endereço.', 'Suporte apenas ao método simple send.'],
    recharge_title: 'Endereço de depósito',
    recharge_btn: ['Copiar', 'QR Code', 'Depositar'],
    recharge_text: ['Quantidade', 'Atenção', 'Não envie ativos não USDT.', 'Suporte apenas simple send.', 'Recibo', 'Descrição (opcional)','Nome da rede'],
    record_title: 'Registro financeiro',
    record_td: ['Quantidade', 'Detalhe', 'Data'],
    transfer_title: 'Transferência',
    transfer_btn: ['Todos', 'Transferir'],
    transfer_text: ['De', 'Para', 'Insira o valor', 'Disponível:'],
    "bq": "Memo",
   "qsrbq":"Insira o memo",
   "yhktx":"Saque bancário",
   "yhmc": "Nome do banco",
   "qsryhmc": "Insira o nome do banco",
   "yhzh": "Conta bancária",
   "qsryhzh":"Insira a conta bancária",
   "gjhkdm": "Código SWIFT/BIC",
   "qsrgjhkdm":"Insira o código SWIFT",
   "yhdz": "Endereço do banco",
   "qsryhdz":"Insira o endereço do banco",
   "skrxm": "Nome do beneficiário",
   "qsrskrxm":"Insira o nome do beneficiário",
   "skrdh": "Telefone do beneficiário",
   "qsrskrdh":"Insira o telefone do beneficiário",
   "skrdz": "Endereço do beneficiário",
   "qsrskrdz":"Insira o endereço do beneficiário"
  },
  text: {
    btn: 'Voltar',
    login: 'Faça o login'
  },
  deal: {
    chooseType: 'Tipo de ordem',
    choose: 'Selecione',
    balance: 'Saldo:',
    account: ['Conta', 'Disponível', '/Bloqueado', 'Transferir'],
    dir: ['Comprar', 'Vender'],
    dir2: ['Comprável', 'Vendável'],
    sxf: 'Taxa',
    jye: 'Valor',
    cs: 'Favoritos',
    sc_list: ['Mercado', 'Par', 'Variação'],
    sc_h: ['Preço atual', 'Mín 24h', 'Máx 24h', 'Volume 24h'],
    td_lt: ['Moeda', 'Último preço', 'Variação'],
    k_line_txt: ['≈', '', 'Variação', 'Máximo', 'Mínimo', 'Volume 24h'],
    tabListLTitle: ["Ordens abertas", "Ordens históricas"],
    tabListLEntrust: ["Comprar", "Vender"],
    tabListRTitle: ["Limite", "Mercado"],
    table_btn: ['Cancelar'],
    index_td_l: ['Data', 'Contraparte', 'Quantidade', 'Preço', 'Ação'],
    index_td_r: ['Preço', 'Direção', 'Preço', 'Quantidade'],
    index_td_r2: ['Última operação', 'Data', 'Preço', 'Volume'],
    table_txt: ['Concluído', 'Cancelado'],
    db_1_txt: ['Disponível', 'Preço de compra', 'Preço de venda', 'Quantidade de compra', 'Quantidade de venda', 'Valor', 'Comprar ao melhor preço', 'Vender ao melhor preço','Comprar lote', 'Vender lote'],
    db_2_txt: ['Preço', 'Alavancagem', 'Selecione', 'Lotes', '1 lote = ', 'lotes', 'Valor do contrato', 'Margem', 'Comprar ao melhor preço', 'Vender ao melhor preço'],
    pathList: ['Registro de contratos', 'Registro de operações'],
    db_btn: ['Comprar (Long)', 'Vender (Short)'],
    tabListLTitle2: ['Ordens abertas'],
    lt_btn: ['Fechar tudo', 'Definir TP/SL', 'Fechar', 'Enviar', 'Voltar'],
    lt_txt: ['Taxa de risco:', 'PnL total:'],
    lt_td: ['Tipo', 'Alavancagem', 'Preço de abertura', 'Preço atual', 'Margem', 'TP', 'SL', 'Data de abertura', 'Lotes', 'PnL', 'Ação'],
    lt_dl: ['Definir TP/SL', 'TP', 'SL'],
    lt_0_btn: ['Cancelar'],
    lt_0_td: ['Contato', 'Moeda', 'Quantidade', 'Preço atual', 'Taxa', 'Ação'],
    lt_1_btn: ['Fechar'],
    lt_1_txt: ['Fechando'],
    lt_1_td: ['Tipo', 'Preço de abertura', 'Preço atual', 'Margem', 'TP', 'SL', 'Data de abertura', 'Taxa', 'PnL', 'Ação'],
    node_data: 'Sem dados',
    lt_3_txt: ['Fechado', 'Liquidado'],
    lt_3_td: ['Tipo', 'Lotes', 'Preço de abertura', 'Preço de fechamento', 'TP', 'SL', 'Margem', 'Margem disponível', 'Abertura', 'Fechamento', 'Taxa', 'PnL', 'Ação'],
    lt_4_txt: ['Cancelado'],
    cm: ['Data de emissão', 'Oferta total', 'Circulação', 'Preço total', 'Site oficial','Whitepaper','Descrição'],
    qsrsl: 'Insira a quantidade',
    qsrss: 'Insira os lotes',
  },
  notice:{
      notice_title:'Central de anúncios',
  },
  bzhl:{
    title: 'Finanças IA',
    title1: 'Quant IA',
    ttzbt: 'Ganho diário',
    wdtg: 'Meus investimentos',
    zztgdzj: 'Capital investido',
    yjjrsy: 'Rendimento diário estimado',
    ljsy: 'Rendimento total',
    tgzdd: 'Ordens em andamento',
    tgdd: 'Ordem de investimento',
    t1: 'Baixo risco, saque flexível',
    t2: 'Seu assistente de gestão de capital',
    cljxcp: 'Duração do produto',
    dbxe: 'Limite por ordem',
    rsyl: 'Rendimento diário (%)',
    rsyl2: 'Rendimento diário:',
    zq: 'Duração',
    qmr: 'Comprar',
    ckgd: 'Ver mais',
    cpgk: 'Visão geral do produto',
    pxsj: 'Data de distribuição',
    tgzj: 'Capital investido',
    tqsh: 'Resgatar',
    cpld: 'Destaques',
    cpgz: 'Regras do produto',
    cont: 'Invista USDT em arbitragem gerenciada por profissionais, acesso e saque flexíveis.',
    zj: '100% capital',
    aqbz: 'Segurança',
    jjrsy: 'Rendimento em feriados',
    bjd: 'contínuo',
    cgcrh: 'Após o depósito',
    dtqx: 'rendimento a partir do mesmo dia',
    ljzr: 'Transferir agora',
    xqglgj: 'Ferramenta de gestão de capital',
    ddh: 'Ordem',
    tgje: 'Valor',
    tgsj: 'Duração (dias)',
    yhl: 'Ganho / dias restantes',
    xdsj: 'Data da ordem',
    zt: 'Status',
    fh: 'Voltar',
    qrnhsy: 'Rendimento anual 7d',
    ygy: '1 mês',
    bn: '6 meses',
    yn: '1 ano',
    yuan: '€',
    tzfx: 'Risco',
    shsc: 'Tempo de resgate',
    di: 'Baixo',
    yggzr: '1 dia útil',
    msgsxf: 'Sem taxa de compra',
    mr: 'Diário',
    dqfh: 'Reembolso no vencimento',
    ljgm: 'Comprar agora',
    tgz: 'Em andamento',
    sh: 'Resgatar',
    ywc: 'Concluído',
    ysh: 'Resgatado',
    all: 'Todos',
    "xzbzts": "Simples, seguro. Escolha entre várias moedas.",
    "qtbz": "Outras moedas"
  },
  pay:{
    qsrjymm: 'Insira a senha de trading (6 dígitos)',
    tbmmts: 'Defina a senha de trading na central do usuário',
  },
  tips:{
    qxztbdz: 'Insira o endereço de saque',
    qsrtbsl: 'Insira a quantidade de saque'
  },
  statusText: ['Falhou','Aguardando','Concluído'],
    dzrz: {
    title: 'Verificação de endereço',
    sdddz: 'Endereço da conta',
    zdtpsc: 'Enviar foto da conta',
    qsrsdddz: 'Insira o endereço e envie a conta',
    qsczdtp: 'Envie a foto da conta'
  },
  jgcc: {
    wtgd: 'Ordem pendente',
    cj: 'Executado',
    jj: 'Introdução',
    zc: 'Em andamento',
    lszc: 'Histórico de posições',
    qblx: 'Todos os tipos',
    xj: 'Preço atual',
    sj: 'Data',
    fx: 'Direção',
    jg: 'Preço',
    sl: 'Quantidade',
    jgsj: 'Data de vencimento',
    gmj: 'Preço de compra',
    jsj: 'Preço de liquidação',
    yk: 'PnL',
    xq: 'Detalhes',
    mz: 'Long',
    md: 'Short',
    dqye: 'Saldo atual',
    gb: 'Fechar',
    jxxd: 'Continuar ordem',
    qrxd: 'Confirmar ordem',
    ddqr: 'Confirmar ordem',
    sxf: 'Taxa',
    kyye: 'Saldo disponível',
    jypz: 'Instrumento',
    jyfx: 'Direção',
    tzje: 'Valor investido',
    tzjeTips: 'O valor não pode ser 0',
    dqsj: 'Vencimento',
    jssj: 'Data de liquidação',
    gmsj: 'Data de compra',
    sy: 'Lucro',
    zxje: 'Quantidade mínima ',
    shi: 'horas',
    fen: 'minutos',
    miao: 'segundos',
    zdje: 'Quantidade máxima ',
    qsrje: 'Insira o valor',
    zxtzje: 'Quantidade mínima ',
    yebz: 'Saldo insuficiente',
    xq: 'Detalhes',
    ddz: 'Aguardando',
    jgjl: 'Registro de vencimentos',
    bz: 'Moeda',
    cz: 'Ação'
  },
  kjmb: {
    title: 'Compra rápida',
    fzcg: 'Copiado',
    ljmb: 'Comprar agora',
    lxkf: 'Contatar suporte'
  },
  news: {
    title: 'Minhas mensagens',
    "gg": "Anúncio",
    ckxq: 'Ver detalhes'
  },
  statusTabs:['Pendente', 'Em execução','Fechado', 'Cancelado'],
  "chongzhi":{
    "zy": "Atenção",
    "cbxx": "Informações de depósito",
    "qsrsl": "Insira a quantidade",
    "tips2": "1. Compatibilidade carteira/plataforma: verifique se a rede é suportada.",
    "tips3": "2. A rede de depósito deve corresponder à rede de destino.",
    "tips4": "3. Verifique o endereço e o valor antes do depósito.",
    "tips5": "Atenção: transações blockchain são anônimas e irreversíveis. Verifique cuidadosamente.",
    "tips2_1": "• Não envie ativos incompatíveis para este endereço.",
    "tips2_2": "• Os tempos de confirmação dependem da rede blockchain.",
    "tips2_3": "• O endereço de depósito é estável e pode ser reutilizado."
  },
  "tibi":{
    "tbxx":"Informações de saque",
    "qsrbq": "Insira o memo",
    "tbTips1": "• Por segurança, os saques podem exigir verificação manual.",
    "tbTips2": "• Certifique-se de que seu dispositivo esteja seguro.",
    "tbTips3": "• O saque reduz o saldo total da moeda selecionada."
  },
  "gjlb": "Lista de países",
  "qxzgjlb": "Selecione país/região",
  "mbwt":{
    "title": "Perguntas de segurança",
    "mbwt": "Pergunta de segurança",
    "problem":[
      { "id": 1, "title": "Qual o nome do seu melhor amigo de infância?" },
      { "id": 2, "title": "Qual é o seu ídolo?" },
      { "id": 3, "title": "Qual é o seu lugar favorito?" }
    ],
    "qtxda": "Insira a resposta",
    "qsrxmm": "Insira a nova senha",
    "qqrmm": "Confirme a senha",
    "sydqmmcz": "Redefinir com senha atual",
    "zhmm": "Recuperar senha com pergunta de segurança",
    "ysz": "Definido",
    "tg": "Pular",
    "tj": "Enviar",
    "zyts": "Importante:",
    "zytsCont": "Não compartilhe suas respostas e códigos de verificação."
  },
  "zc":{
    "zclb": "Lista de ativos",
    "zczh": "Total de ativos",
    "yczc": "Ocultar ativos com saldo 0"
  },
  "indexNew":{
    "t1": "Plataforma líder global",
    "t2": "para ativos digitais",
    "t3": "Plataforma completa para negociação de ativos digitais blockchain",
    "t4": "Telefone/E-mail",
    "t5": "Registre-se agora",
    "t6": "Recebemos clientes de todo o mundo",
    "t7":"para iniciar sua jornada cripto"
  },
  "newReg":{
    "dl": ['E-mail','Telefone'],
    "cjzh": "Criar conta",
    "sysjhzyx": "Registre-se com telefone ou e-mail",
    "yhxy": "Termos de serviço",
    "yhxy2": "Li e aceito os termos",
    "yxgz": "Formato de e-mail inválido",
    "dhgz": "Formato de telefone inválido"
  },
  "indexNew2":{
    "t1": "Negocie em nossa plataforma",
    "t2": "Com o Bitbank",
    "t3": "Bitbank é uma exchange crypto segura, simples e poderosa. Suporte multi-dispositivo, mais de 60 indicadores técnicos. Comece agora.",
    "ksjy": "Comece a negociar",
    "ly": "5 motivos para escolher o Bitbank",
    "item1_t1": "Volume líder",
    "item1_t2": "Nº 1 * volume crypto",
    "item1_t3": "Alta liquidez, 12 criptos disponíveis.",
    "item2_t1": "Alta avaliação de terceiros",
    "item2_t2": "Ambiente seguro",
    "item2_t3": "Carteira cold e multisig para máxima segurança.",
    "item3_t1": "App fácil e confiável",
    "item3_t2": "App intuitivo",
    "item3_t3": "Funcionalidades completas, negocie em qualquer lugar.",
    "item4_t1": "24/7",
    "item4_t2": "Depósitos sempre disponíveis",
    "item4_t3": "Suporte a depósitos 24 horas, inclusive feriados.",
    "item5_t1": "Smartphone e PC",
    "item5_t2": "Design amigável",
    "item5_t3": "Trading simples mesmo no celular.",
    "aqkk": "Seguro e confiável",
    "aqkk2": "Negocie Bitcoin no Bitbank",
    "cjzh": "Crie uma conta"
  },
  "xbsg":{
    "title": "Novas criptos",
    "wdsg": "Minhas subscrições",
    "scts": "Bloqueio (dias):",
    "sy": "Restante",
    "ljsg": "Subscrever agora",
    "ysk": "Esgotado",
    "xzjdy": "Inscreva-se agora",
    "dy": "Inscrever",
    "fxjg": "Preço de emissão",
    "fxl": "Oferta total",
    "ssrq": "Data de listagem",
    "yxqx": "Validade",
    "qsrsl": "Insira a quantidade",
    "syl": "Restante",
    "sgrq": "Data de subscrição",
    "sgsl": "Quantidade",
    "bz": "Moeda",
    "yebz": "Saldo USDT insuficiente",
    "tgsl": "Quantidade aprovada",
    "shz": "Em verificação",
    "wtg": "Não aprovado",
    "ytg": "Aprovado"
  },
  "wydb":{
    "title": "Solicitar empréstimo",
    "db": "Empréstimo",
    "dbz": "Em andamento",
    "jl": "Registro de empréstimos",
    "jdzq": "Duração (dias)",
    "qhk": "Pagar",
    "ljdb": "Total de empréstimos (USD)",
    "dhkbs": "A pagar",
    "jkje": "Valor (USDT)",
    "qsrje": "Insira o valor",
    "rll": "Taxa diária",
    "hkfs": "Forma de pagamento",
    "dqych": "Pagamento no vencimento",
    "lx": "Juros",
    "fkjg": "Instituição financiadora",
    "tpsc": "Empréstimo fideicomisso (enviar foto)",
    "fwxx": "Informações do imóvel",
    "srzm": "Comprovante de renda",
    "yhmx": "Extrato bancário",
    "zjz": "Foto do documento",
    "yd": "Li e aceito",
    "xy": "Acordo de empréstimo",
    "sqdb": "Solicitar empréstimo",
    "gb": "Fechar",
    "qd": "Confirmar",
    "ts": "Aceite os termos do empréstimo",
    "dbjl": "Registro de empréstimos",
    "hkhth": "Contrato",
    "wsh": "Em verificação",
    "yfk": "Liberado",
    "sqrq": "Data da solicitação",
    "zq": "Duração",
    "dbsl": "Valor",
    "zhke": "Total a pagar",
    "yhke": "Já pago",
    "yhkxq": "Detalhe do pagamento",
    "bqyhk": "Parcela atual (USDT)",
    "hktips": "Certifique-se de ter saldo suficiente",
    "bj": "Principal",
    "jie": "Empréstimo",
    "ljhk": "Pagar agora",
    "qcz": "Recarregar",
    "yebzqxcz": "Saldo insuficiente, recarregue primeiro",
    "znj": "Multa",
    "yqts": "Dias de atraso"
  },
  "hkxq":{
    "dd":"Ordem",
    "fzhkdz":"Copiar endereço de pagamento",
    "hkxq": "Detalhe do pagamento",
    "zlx": "Juros totais",
    "zhk": "Total a pagar",
    "hkjg": "Instituição",
    "qschkpz": "Enviar comprovante de pagamento",
    "hkpz": "Comprovante de pagamento"
  },
  "bbjyNew":{
    "jylx": "Tipo de trading",
    "jyze": "Volume total"
  },
  "bind":{
    "title": "Verificação de e-mail",
    "ybd": "Associado",
    "wbd": "Não associado",
    "ts": "Associe o e-mail para mais segurança",
    "qsryxdz": "Insira o e-mail"
  },
  "tipsNew": {
    "yjj": "Recusado",
    "shz": "Em resgate"
  },
  "newIndex2":{
    "zxhy": "Últimos preços",
    "jypt": "Plataforma",
    "ssyc": "Ocultar",
    "hwzc": "Não registrado?",
    "ljzc": "Registre-se agora!",
    "yyzh": "Já tem uma conta?",
    "hjbj": "Acesse, bem-vindo de volta!",
    "lmdh": "Menu",
    "ghdjy": "Melhor trading, melhor vida",
    "ghdjy02": "O centro de trading mais inovador do mundo, centenas de criptos disponíveis.",
    "indexCont01": "Sempre ao seu lado",
    "indexCont02": "Trading spot e margin com execução ultrarrápida.",
    "indexCont03": "API poderosa",
    "indexCont04": "API intuitiva e opções avançadas.",
    "indexCont05": "Ativos digitais de qualidade",
    "indexCont06": "9 anos 0 incidentes",
    "indexCont07": "Segurança top",
    "indexCont08": "Alavancagem até 25x",
    "indexCont09": "Negocie CFDs de Bitcoin com alavancagem 25x.",
    "indexCont10": "Fundo de segurança",
    "indexCont11": "Liquidez profunda",
    "indexCont12": "Tecnologia avançada para spreads reduzidos.",
    "indexCont13": "Escolhido pelos usuários",
    "indexCont14": "Países atendidos",
    "indexCont15": "Nossas vantagens",
    "indexCont16": "Trading spot e margin com execução rápida.",
    "indexCont17": "Armazenamento seguro",
    "indexCont18": "Carteira cold e MPC para gestão de ativos.",
    "indexCont19": "Segurança em primeiro lugar",
    "indexCont20": "Tecnologia de ponta para proteger seus fundos.",
    "indexCont21": "Saques rápidos",
    "indexCont22": "Saques 24/7 com altos padrões de segurança.",
    "indexCont23": "Compre e venda criptomoedas",
    "indexCont24": "Junte-se à plataforma mais completa e segura",
    "indexCont25": "Compre e venda BTC, ETH, XRP e muitas outras criptos.",
    "yqwj": "10M+",
    "dlzc": "Acessar/Registrar",
    "yzm": "Código de verificação",
    "qrmm": "Confirmar senha"
  },
  "langNew2":{
    "flzq": "Área de recompensas",
    "qdjl": "Recompensa de check-in",
    "mrqdjl": "Recompensa diária",
    "qd": "Check-in",
    "yqd": "Já feito",
    "hdgz": "Regras",
    "qdjl2": "Histórico de check-in",
    "qdcg": "Check-in concluído",
    "yhd": "Obtido",
    "lq": "Retirar",
    "dyt": "Dia 1",
    "det": "Dia 2",
    "dst": "Dia 3",
    "dsit": "Dia 4",
    "dwt": "Dia 5",
    "dlt": "Dia 6",
    "dqt": "Dia 7",
    "jxz": "Em andamento",
    "cjxnzh": "Criar conta demo",
    "sy":"Início",
    "sc":"Mercado",
    "sclb":"Lista de mercados",
    "jy":"Trading",
    "zh":"Conta",
    "db":"Empréstimo",
    "zchm":"Número de registro",
    "cp":"Produtos",
    "tzjd":"Investimentos e empréstimos",
    "zxzc":"Suporte online",
    "xd":"Ordem",
    "zzjptgmnr":"Invista no futuro, acesse um sistema financeiro justo.",
    "yy":"App",
    "pqnr":"Banco móvel sem regras tradicionais.",
    "jiami":"Cripto",
    "tgnr":"Depósitos cripto para mais segurança e velocidade.",
    "jyl":"Volume médio 24h",
    "ssjmhb":"Criptos listadas",
    "zchy":"Usuários registrados",
    "djxz":"Baixe agora",
    "azsc":"Android",
    "pgsd":"Apple Store",
    "bqxx":'©Copyright ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. Todos os direitos reservados.',
  },
   "login":{
     login: 'Bem-vindo',
     msg: 'Insira sua conta',
     list: ['Telefone/E-mail', 'Senha', 'Esqueceu a senha?', 'Acessar', 'Não tem conta? Registre-se'],
     message: 'Conta ou senha não podem estar vazios',
     "cdlks":"Acesse para começar!",
     "zh":"Conta",
     "qsrzh":"Insira a conta",
     "mm":"Senha",
     "qsrmm":"Insira a senha",
     "dl":"Acessar",
     "wjmm":"Esqueceu a senha",
     "qbdl":"Acesse com carteira",
     "myzh":"Não tenho conta?",
     "zc":"Registrar",
     "yzm":"Código de verificação",
     "qsryzm":"Insira o código",
     "hqyzm":"Obter código",
     "qrmm":"Confirmar senha",
     "qsrqrmm":"Confirme a senha",
     "lcmmbyz":"As senhas não coincidem",
     "mmts":"Senha de 6 a 12 caracteres",
     "sjtx":"Formato de telefone inválido",
     "yxts":"Formato de e-mail inválido",
     "qr":"Confirmar",
     "sjzc":"Registrar com telefone",
     "sjh":"Telefone",
     "qsrsjh":"Insira o telefone",
     "yqm":"Código de convite (opcional)",
     "qsryqm":"Insira o código de convite",
     "yxzc":"Registrar com e-mail",
     "wyydbzx":"Aceito",
     "yhxy":"Termos de serviço",
     "yhxy2":"Termos de serviço",
     "ysyx":"Política de privacidade",
     "yx":"E-mail",
     "qsryx":"Insira o e-mail",
     "yxgsbzc":"Formato de e-mail inválido",
     "cjmnzhcg":"Conta demo criada",
     "tcmnzh":"Sair da conta demo",
     "qbdlts":"Use o app DAPP Wallet",
     },
     "hq":{
     "wh":"Forex",
     "szhb":"Criptomoedas",
     "gp":"Ações",
     "zs":"Índices",
     "eft":"ETF",
     "mc":"Nome",
     "xs":"Variação 24h %",
     "tb":"Gráfico",
     "jg":"Preço",
     },
     "user":{
     "wdzh":"Minha conta",
     "zh":"Conta:",
     "dk":"Empréstimo:",
     "sydbzj":"Margem utilizada:",
     "yqll":"Lucro esperado:",
     "qtgn":"Outras funções",
     "cz":"Depósito",
     "tx":"Saque",
     "dh":"Troca",
     "zhyz":"Verificação KYC",
     "zhjl":"Registro da conta",
     "yqhy":"Convidar amigos",
     "flzq":"Área de recompensas",
     "ggmm":"Alterar senha",
     "sz":"Configurações",
     "cjwtjd":"FAQ",
     "fzdz":"Copiar endereço",
     "sl":"Quantidade...",
     "qsrsl":"Insira a quantidade",
     "dd":"Receber (USDT):",
     "sczm":"Enviar comprovante",
     "qsczm":"Envie o comprovante",
     "tj":"Enviar",
     "czjl":"Registro de depósitos",
     "ddh":"Ordem",
     "wsh":"Em verificação",
     "ywc":"Concluído",
     "bz":"Nome:",
     "sl2":"Quantidade:",
     "sj":"Data:",
     "srsl":"Insira a quantidade...",
     "dd2":"Receber:",
     "qskgzflhd":"Acompanhe as promoções, publicaremos eventos regularmente",
     "hdlb":"Lista de eventos",
     "ckxq":"Ver detalhes",
     "wdjl":"Minhas recompensas",
     "yiji":"Nível 1",
     "erji":"Nível 2",
     "sanji":"Nível 3",
     "je":"Valor",
     "sj2":"Data",
     "yyxz":"Selecionar idioma",
     "tcdl":"Sair",
     "je2":"Valor (USD)...",
     "qsrje":"Insira o valor",
     "jsdz":"Endereço de destino...",
     "qsrjsdz":"Insira o endereço",
     "sjdz":"Valor líquido:",
     "sxf":"Taxa:",
     "txsm1":"O saque requer uma taxa de 5%, confirmada pelos nós da rede.",
     "txsm2":"Não transfira cripto para estranhos.",
     "tz":"Notificações",
     "wdyq":"Meus convites",
     "yhid":"ID do usuário",
     "hdjl":"Recompensa em USD",
     "yqsm":"Convide amigos para participar do Quant IA, alugar mineradores ou negociar para ganhar recompensas.",
     "yqsy":"Ganho com convites",
     "yqrs":"Pessoas convidadas",
     "tgljyq":"Convidar via link",
     "lj":"Link",
     "yqm":"Código de convite",
     "cbtb":"Depósito/Saque de cripto",
     "jymx":"Detalhe de transações",
     "yqhyjl":"Recompensa de convites",
     "aidd":"Ordens AI Gold",
     "jdls":"Histórico de empréstimos",
     "etfdd":"Ordens ETF",
     "jmhbdd":"Ordens cripto",
     "whdd":"Ordens forex",
     "gpdd":"Ordens de ações",
     "qx":"Cancelar",
     "zc":"Ativos",
     "zzc":"Total de ativos",
     "ky":"Disponível",
     "zh2":"Equivalente (USD)",
     "xzbz":"Selecione:",
     "sztkts":"Nota: defina a senha de trading na central de segurança.",
     "jymm":"Senha de trading",
     "szjymm":"Definir senha de trading",
     "qsrjymm":"Insira a senha de trading",
     "zdsl":"Quantidade mínima",
     "bq":"Memo",
     "qsrbq":"Insira o memo",
     "yhktx":"Transferência bancária",
     "yhmc":"Nome do banco",
     "qsryhmc":"Insira o nome do banco",
     "yhzh":"Conta bancária",
     "qsryhzh":"Insira a conta",
     "gjhkdm":"Código SWIFT",
     "qsrgjhkdm":"Insira o SWIFT",
     "yhdz":"Endereço do banco",
     "qsryhdz":"Insira o endereço",
     "skrxm":"Nome do beneficiário",
     "qsrskrxm":"Insira o nome",
     "skrdh":"Telefone do beneficiário",
     "qsrskrdh":"Insira o telefone",
     "skrdz":"Endereço do beneficiário",
     "qsrskrdz":"Insira o endereço",
     "tbjl":"Registro de saques",
     "fzcg":"Copiado",
     "aqzx":"Central de segurança",
     "yxrz":"Verificação de e-mail",
     "ybd":"Associado",
     "wbd":"Não associado",
     "yrz":"Verificado",
     "wrz":"Não verificado",
     "ts":"Associe o e-mail para mais segurança",
     "qsryxdz":"Insira o e-mail",
     "dlmm":"Senha de acesso",
     "mbwtsz":"Perguntas de segurança",
     "mbwt":"Pergunta",
     "qtxda":"Insira a resposta",
     "zyts":"Importante:",
     "zytsCont":"Não compartilhe respostas e códigos.",
     "qsrxmm":"Insira a nova senha",
     "sydqmmcz":"Redefinir com senha atual",
     "zhmm":"Recuperar com pergunta de segurança",
     "ysz":"Definido",
     "tg":"Pular",
     "qsrdlmm":"Insira a senha de acesso",
     "bzxz":"Selecione",
     "zwsj":"Sem dados",
     "qd":"Confirmar",
     "zsgd":"Mostrar mais",
     "zdss":"Lote mínimo",
     "mnjy":"Trading demo",
     "sx":"Filtrar",
     },
     "zb":{
     "tgdd":"Ordens AI em gestão",
     "tgz":"Em gestão",
     "ysh":"Resgatado",
     "shz":"Em resgate",
     "zq":"Duração:",
     "tian":"dias",
     "syl2":"Rendimento:",
     "rgjg":"Preço de subscrição:",
     "rgjg2":"Preço de subscrição",
     "xdsj":"Data da ordem:",
     "yhl":"Ganho:",
     "syts":"Dias restantes:",
     "sh":"Resgatar",
     "syl":"Rendimento",
     "bz":"Nome",
     "dl":"Taxa",
     "tgts":"Dias de gestão:",
     "tgsl":"Quantidade",
     "qsrtgsl":"Insira a quantidade",
     "dbxe":"Limite por ordem ",
     "ljtg":"Investir agora",
     "zztg":"Valor investido",
     "yjjrsy":"Rendimento estimado hoje",
     "ljsy":"Rendimento total",
     "tgzdd":"Ordens em andamento",
     "ljzc":"Transferir agora",
     "gz":"Regras",
     "cpzq":"Duração do produto",
     "gm":"Comprar",
     "ts":"Atenção",
     "shts":"O resgate antecipado implica multa de 5%. Confirma?",
     "xgcs":"Limite de compras",
     },
     "dk":{
     "dk":"Empréstimo",
     "dkzh":"Conta de empréstimo",
     "yzsf":"Verifique sua identidade para obter valores maiores!",
     "ksyz":"Iniciar verificação",
     "wxj":"Quero pedir emprestado...",
     "dkqx":"Duração (dias):",
     "mrll":"Taxa diária:",
     "lxze":"Juros totais:",
     "dkts":"Os primeiros 3 dias sem juros.",
     "xzj":"Solicitar agora",
     "wyydbzx":"Aceito",
     "dkfwxy":"Acordo de empréstimo",
     "dkfwxy2":"Acordo de empréstimo",
     "dkysxy":"Acordo de privacidade de empréstimo",
     "dkjl":"Registro de empréstimos",
     "hth":"Contrato",
     "yfk":"Liberado",
     "lx":"Juros:",
     "zhke":"Total a pagar:",
     "znj":"Multa:",
     "znjl":"Taxa de multa:",
     "yqts":"Dias de atraso:",
     "qhk":"Pagar",
     "tpsc":"Empréstimo fiduciário (enviar foto)",
     "fwxx":"Info do imóvel",
     "srzm":"Comprovante de renda",
     "yhmx":"Extrato bancário",
     "zjz":"Foto do documento",
     "ljdk":"Solicitar agora",
     "xm":"Nome",
     "ndxm":"Seu nome",
     "qsrndxm":"Insira seu nome",
     "gj":"País",
     "ndgj":"Seu país",
     "qsrndgj":"Insira seu país",
     "dz":"Endereço",
     "nddz":"Seu endereço",
     "qsrnddz":"Insira seu endereço",
     "csrq":"Data de nascimento",
     "ndcsrq":"Sua data de nascimento",
     "qsrndcsrq":"Insira sua data de nascimento",
     "dhhm":"Telefone",
     "nddhhm":"Seu telefone",
     "qsrnddhhm":"Insira seu telefone",
     "zj":"Documento",
     "sfzm":"Frente do documento",
     "qscsfzm":"Envie a frente",
     "sffm":"Verso do documento",
     "qscsffm":"Envie o verso",
     "ddqr":"Confirmar ordem",
     "jk":"Empréstimo:",
     "dkqx2":"Duração:",
     "qrxd":"Confirmar ordem",
     "yhkxq":"Detalhe do pagamento",
     "hkqr":"Confirmar pagamento",
     "yhk":"A pagar:",
     "jksj":"Data do empréstimo:",
     "ljhk":"Pagar agora",
     },
     "jy":{
       "rq":"Data",
       "qqjy":"Registro de opções",
     "hyjy":"Trading de contratos",
     "qqhy":"Contratos de opções",
     "dqwt":"Ordens abertas",
     'wtz':"Pendente",
     "hyjl":"Registro de contratos",
     "shou":"lote",
     "dk":"Abrir:",
     "zhjg":"Último preço:",
     "jyfy":"Taxa:",
     "kfsj":"Data de abertura:",
     "gg":"Alavancagem:",
     "pl":"Lote:",
     "kpj":"Preço de abertura:",
     "yk":"PnL:",
     "cd":"Cancelar",
     "jsj":"Preço de liquidação:",
     "fx":"Direção:",
     "jgsj":"Data de vencimento:",
     "gb":"Fechar",
     "jxxd":"Continuar",
     "xj":"Limite:",
     "gm":"Comprar:",
     "sl":"Quantidade",
     "fy":"Taxa:",
     "tzbzj":"Ajustar margem",
     "zyzs":"TP/SL",
     "pc":"Fechar posição",
     "mr":"Comprar",
     "zjbzj":"Adicionar margem",
     "jsbzj":"Reduzir margem",
     "yxhy":"Trading de contratos:",
     "cc":"Posição (contratos):",
     "cc2":"Posição",
     "cwbzk":"Margem da posição:",
     "zdzjbzj":"Margem máxima adicionável:",
     "zjbzj2":"Adicionar margem:",
     "qsrzbzj":"Insira a margem",
     "yxhy2":"Contratos perpétuos",
     "kp":"Fechável",
     "zhang":"contratos",
     "xj2":"Limite",
     "zy":"Take Profit",
     "zs":"Stop Loss",
     "ssjyzl":"Buscar instrumentos",
     "ddb":"Volume",
     "di":"Mín:",
     "gao":"Máx:",
     "gb2":"Fechar:",
     "fz":"minutos",
     "mai":"Comprar:",
     "zhang2":"Long",
     "tie":"Short",
     "sy":"Lucro",
     "kz":"Call",
     "kt":"Put",
     "bndy":"Não inferior a ",
     "sxbzj":"Margem necessária:",
     "ky":"Disponível:",
     "sj":"Mercado",
     "mc":"Vender",
     "zxtzsl":"Quantidade mínima ",
     "min":"Mín ",
     "max":"Máx ",
     "yebz":"Saldo insuficiente",
     "ddz":"Aguardando",
     "wtzl":"Volume de ordens:",
     "wtjg":"Preço da ordem:",
     "ycd":"Ordem cancelada",
     "lswt":"Registro de contratos",
     "qsrzyjg":"Insira o TP",
     "qsrzsjg":"Insira o SL",
     "ccsl":"Quantidade da posição:",
     "ccjg":"Preço da posição:",
     "ggbs":"Alavancagem:",
     "zy2":"TP:",
     "zs2":"SL:",
     "zje":"Total:",
     "ss":"Lotes:",
     "kcjg":"Preço de abertura:",
     "bzjl":"Margem:",
     "lscc":"Histórico de posições",
     "gmj":"Preço de compra:",
     "guadan":"Ordem limite",
     "dqjg":"Preço atual:",
     "gdjg":"Preço da ordem:",
     "pcjg":"Preço de fechamento:",
     "ccsj":"Tempo em posição:",
     "gdsj":"Tempo da ordem:",
     "pcsj":"Tempo de fechamento:",
     "fdjyk":"PnL flutuante",
     "pcsl":"Quantidade a fechar",
     "qrpc":"Confirmar fechamento",
     "ypc":"Fechado",
     "ss2":"Lotes",
     "qsrss":"Insira os lotes"
     },
     "gjrz":{
     "sfyz":"Verificação KYC",
     "t1":"1. Formatos JPG, JPEG, PNG, máx 8MB.",
     "t2":"2. Fotos nítidas, sem alterações ou coberturas.",
     "t3":"3. Foto sem chapéu, rosto e braços bem visíveis.",
     "t4":"Confirmar",
     "bh":"Rejeitado",
     "shz":"Em verificação",
     "shtg":"Verificado",
     "nyrzcg":"Verificação concluída",
     "sczjz":"Enviar foto do documento",
     "sczjzmz":"Enviar frente",
     "sczjbmz":"Enviar verso",
     "scgrqmz":"Enviar foto com documento",
     "gjlb":"Lista de países",
     "qxzgjlb":"Selecione o país",
     "zsxm":"Nome completo",
     "qsrzsxm":"Insira o nome completo",
     "zjlx":"Tipo de documento",
     "zjhm":"Número do documento",
     "qsrzjhm":"Insira o número do documento",
     "khh":"Banco",
     "qsrkhh":"Insira o banco",
     "yhkh":"Número da conta",
     "qsryhkh":"Insira o número da conta",
     },
     "status":{
     "statusText":['Falhou','Aguardando','Concluído'],
     },
     "download":{
     "t1":"Trading móvel, em qualquer lugar",
     "xz":"Baixar"
     },
     "langNew":{
       "jmm": "Senha antiga",
       "qsrjmm": "Insira a senha antiga",
       "szhb": "Criptomoedas",
       "gjs": "Metais preciosos",
       "ny": "Energia",
       "yy": "Petróleo",
       "jy": "Trading",
       "jmhb": "Criptomoedas",
       "yxhy": "Contratos perpétuos",
       "gdjy": "Ordens limite",
       "khh": "Banco",
       "qsrkhh": "Insira o banco",
       "yhkh": "Número da conta",
       "qsryhkh": "Insira o número da conta",
     "mnzh":"Conta demo",
     "zjjypt":"Melhor plataforma de trading",
     "brjmzndxq":"Tecnologia de ponta para todas as suas necessidades",
     "jx":"Continuar",
     "yssm":"Política de privacidade",
     "fxqzc":"Política antilavagem de dinheiro",
     "jgxkz":"Licenças regulatórias",
     "ckgd":"Ver mais",
     "gd":"Mais",
     "dd":"Ordem",
     "ckdd":"Ver ordem",
     "yxdd":"Ordem perpétua",
     "qqdd":"Ordem de opções",
     "hand":"1 lote =",
     "lxwm":"Contate-nos",
     "tpfzl":"Arraste sua imagem aqui ou",
     "liulang":"Navegar",
     "zctpgs":"Suporte: JPG, JPEG2000, PNG",
     "ysr":"Renda mensal",
     "ndysr":"Sua renda mensal",
     "qsrndysr":"Insira sua renda mensal",
     "yqtzje":"Valor de investimento previsto",
     "qsrtzje":"Insira o valor previsto",
     "zszh":"Conta real",
     "qdl":"Acesse",
     "zx":"Favoritos",
     "hkdz":"Endereço de pagamento",
     "dkje":"Valor do empréstimo:",
     "zlx":"Juros totais:",
     "hkze":"Total a pagar:",
     "qcz":"Recarregar",
     "yebz":"Saldo insuficiente, recarregue",
     "dhje":"Valor a pagar:",
     "hkjl":"Registro de pagamentos:",
     "hkje":"Valor do pagamento:",
     "kyye":"Saldo disponível:",
     "qb": 'Todos',
     "lmc": "Nome da rede:",
     "search": "Buscar",
     "mrjg":"Preço de compra",
     "lxkf":"Contatar suporte",
     "wyj":"Multa",
     "yxsj":"Duração:",
     "jssj":"Data de término:",
     "hksj":"Data do pagamento:",
     "sysj":"Tempo restante:",
     "jkqx":"Duração do empréstimo:",
     "yq":"Atrasado:",
     "qqss":"Sua ordem de opções expirou, perda de",
     "qqlr":"Sua ordem de opções expirou, lucro de",
     "bz":"Moeda",
     "dzje":"Valor líquido",
     "lxyxzc":"Suporte por e-mail",
     },
     "langNew9":{
      "dzje":"Tendências do mercado",
      "lxyxzc":"Inicie sua jornada no trading digital",
      "text1":"Comece criando uma conta",
      "text2":"Convide amigos para o MFTG",
      "text3":"Faça um depósito",
      "text4":"Suporte multi-moeda para começar rapidamente",
      "text5":"Comece a negociar",
      "text6":"Muitos pares de qualidade no MFTG",
      "text7":"Convide amigos e ganhe USDT",
      "text8":"Ganhe USDT convidando amigos",
      "text9":"Funcionalidade de empréstimo ativa",
      "text10":"Solicite um empréstimo, liberação no mesmo dia",
      "text11":"Negocie todos os ativos",
      "text12":"Forex, cripto, futuros, ETFs e mais",
      },
      "bank":{
        "text1":"A plataforma financeira mais confiável",
        "text2":"Notícias em tempo real",
        "text3":"Atualizações do mundo financeiro",
        "text4":"Comece a explorar",
        "text5":"Notícias rápidas",
        "text6":"Selecione o banco",
        "text7":"Cartão bancário",
        "text8":"Valor...",
        "text9":"Adicionar cartão",
        "text10":"Conta bancária",
        "text11":"Insira a conta",
        "text12":"ID do cartão",
        "text13":"Insira o ID do cartão",
        "text14":"Código internacional",
        "text15":"Insira o código",
        "text16":"Insira o telefone",
        "text17":"Adicionar",
        "text18":"Excluir cartão",
        "text19":"Valor líquido",
        "text20":"Informações de saque",
        "text21":"Selecione o cartão",
        "text22":"Avisos",
        "text23":"Valor mínimo de saque:",
        "text24":"Valor inferior ao mínimo não permitido",
        "text25":"• Os saques podem exigir verificação manual.",
        "text26":"• Verifique a segurança do dispositivo.",
        "text27":"• Cada saque reduz o saldo total.",
        "text28":"Registro de saques",
        "text29":"Tipo de moeda fiduciária",
      },
      "team":{
        "tdjs":"Nossa equipe",
        "wmdtd":"Nossa equipe",
        "tdjj":"Oferecemos custos reduzidos, melhor execução e serviços financeiros seguros. Junte-se a nós.",
        "gltdjs":"Equipe de gestão",
        "mc0":"Christian James Oram",
        "mc1":"Ari Cohen",
        "mc2":"David Charles Harrison",
        "mc3":"David Harding",
        "mc4":"Marcus John Fisher",
        "mc5":"Michael Levin",
        "mc6":"Robin Matthews",
        "mc7":"Satya Raito",
        "zc0":"CEO",
        "zc1":"CTO",
        "zc2":"CFO",
        "zc3":"Consultor jurídico",
        "zc4":"COO",
        "zc5":"CIO",
        "zc6":"Diretor de Crédito",
        "zc7":"Diretor de Dados e IA",
        "text01":"Segurança e transparência",
        "text02":"A segurança dos usuários é nossa prioridade",
        "text03":"Licenças regulatórias internacionais",
        "text04":"Protocolos de proteção de ativos",
        "text05":"Auditoria independente",
        "text06":"Condições de trading ideais",
        "text07":"Experiência de trading superior",
        "text08":"Suporte a múltiplos instrumentos",
        "text09":"Execução de ordens eficiente",
        "text10":"Dados K-line profissionais",
        "text11":"Pronto para começar sua carreira conosco?",
        "ljks":"Comece agora",
        "技术副总裁":"Vice-Presidente de Tecnologia",
        "公共关系与对外事务总监":"Diretor de Relações Públicas",
        "首席战略官":"Diretor de Estratégia",
        "首席人工智能科学家":"Cientista Chefe de IA",
        "首席风险官":"Diretor de Risco",
      },
      "aiDetail":{
        "syxq":"Detalhe de ganhos",
        "zsy":"Ganho total",
        "rq":"Data",
      },
      kdkje: 'Valor disponível para empréstimo'
}


// WEBPACK FOOTER //
// ./src/lang/pt.js